import Form from './form'
import React, { useState, useLayoutEffect } from 'react'
import { requestSocialBadgeDetailPromise } from 'api/SocialBadge'

export default function ChallengeEdit (props) {
  const [data, setData] = useState({})
  const { match: { params: { id } } } = props

  useLayoutEffect(() => {
    requestSocialBadgeDetailPromise(id).then(resp => setData(resp))
  }, [id])
  return (
    <Form { ...props } data={data} />
  )
}
